import React, {Fragment} from 'react';

import {MainFooter} from 'presentation/components';
import {FilterDateHeader} from './components/FilterDateHeader';
import {HistoryList} from './components/HistoryList';

function OldHistoryPage() {
	return (
		<Fragment>
			<FilterDateHeader />
			<HistoryList />
			<MainFooter />
		</Fragment>
	);
}

export {OldHistoryPage};
